import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import {
    DecodedToken,
    ImpersonationToken
} from '../../../../core/state/session/session.store';
import { User } from '../../state/users/user.model';

export interface ImpersonateState {
    userId: User['id'];
    token: ImpersonationToken;
    decodedToken: DecodedToken;
}

export function createInitialState(): ImpersonateState {
    return {
        userId: null,
        token: null,
        decodedToken: null
    };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'impersonate', resettable: true })
export class ImpersonateStore extends Store<ImpersonateState> {
    constructor() {
        super(createInitialState());
    }
}
